import * as React from "react";
import tmpReact from "@Tmp/Helpers";

function Input(props) {
    const onChange = (e) => {
        if (props.onChange) {
            props.onChange(e);
        }
    };

    const onKeyUpEnter = (e) => {
        if (props?.input?.onKeyUp) {
            props?.input?.onKeyUp(e);
        }

        if (e.key === "Enter" && props.action) {
            props.action();
        }
    };

    const classes = props.classes ? props.classes : {};

    if (!classes.input_container) {
        classes.input_container = [];
    }

    if (props.error_message) {
        classes.input_container.push("tmp-input-error");
    }

    let wrapper_attr = props.wrapper ? { ...props.wrapper } : {};
    let input_attr = props.input ? { ...props.input } : {};

    input_attr["data-name"] = props.name;

    if (!input_attr.type) {
        input_attr.type = "text";
    }

    input_attr.onKeyUp = onKeyUpEnter;

    const input_styles: any = {};

    if (props.icon_before) {
        input_styles.paddingLeft = 0;
    }

    if (props.icon_after) {
        input_styles.paddingRight = 0;
    }

    if (input_styles) {
        if (input_attr.style) {
            input_attr.style = jQuery.extend(input_attr.style, input_styles);
        } else {
            input_attr.style = input_styles;
        }
    }

    let icon_after_container: any = {};
    if (props.icon_after_container) {
        icon_after_container = props.icon_after_container;
    }

    icon_after_container.className = "tmp-input-icon-container " + icon_after_container.className;

    return (
        <label className={tmpReact.printClasses(classes.label, ["tmp-label"])} {...wrapper_attr}>
            <div className="tmp-label-text">
                {props.label ? props.label : ""}
                {props.labelContent ? props.labelContent() : ""}
            </div>
            <div
                className={tmpReact.printClasses(classes.input_container, ["tmp-input-container"])}
            >
                {props.icon_before ? (
                    <div className="tmp-input-icon-container">
                        <i className={props.icon_before}></i>
                    </div>
                ) : (
                    ""
                )}
                <input
                    className={tmpReact.printClasses(classes.input, ["tmp-input"])}
                    {...input_attr}
                    value={props.value}
                    onChange={onChange}
                />
                {props.icon_after ? (
                    <div {...icon_after_container}>
                        <i className={props.icon_after}></i>
                    </div>
                ) : (
                    ""
                )}
            </div>
            {props.error_message ? (
                <div className="tmp-input-error-message">{props.error_message}</div>
            ) : (
                ""
            )}

            {props.success_message ? (
                <div className="tmp-input-success-message">{props.success_message}</div>
            ) : (
                ""
            )}
        </label>
    );
}

export default Input;
